import React from 'react'
import Layout from '../../common/Layout'
import AdviserProfileContainer from '../../features/AdviserProfile/AdviserProfileContainer/AdviserProfileContainer'
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
  path: '/adviser/:adviserName/:id/profile/view',
  async action ({ params }) {
    const adviserId = parseInt(params.id)
    var adviserName = decodeURIComponent(params.adviserName.split('_').join(' '))
    return {
      title: `Allan Gray | ${adviserName} | Profile`,
      component: <Layout containerWell backButtonText={'Back to search results'}>
        <AdviserProfileContainer adviserId={adviserId} />
      </Layout>
    }
  }
}
